export default {
    data: () => ({
        translations: {
            addStore: {
                el: "Προσθήκη Καταστήματος",
                en: "Add Store",
                it: "Aggiungi negozio"
            },
            rights: {
                el: "Δικαιώματα",
                en: "Rights",
                it: "Diritti"
            },
            code: {
                el: "Κωδικός",
                en: "Code",
                it: "Codice"
            },
            name: {
                el: "Όνομα",
                en: "Name",
                it: "Nome"
            },
            storeName: {
                el: "Εμφανιζόμενο Όνομα Καταστήματος (εφαρμογή)",
                en: "App Display Name",
                it: "Nome visualizzato dell'app"
            },
            map: {
                el: "Ορατό στο Χάρτη",
                en: "Visible On Map",
                it: "Visibile sulla mappa"
            },
            payments: {
                el: "Online Πληρωμές",
                en: "Accept Online Payments",
                it: "Pagamenti online"
            },
            view: {
                el: "Προβολή",
                en: "View",
                it: "Vedi"
            },
            active: {
                el: "Ενεργό",
                en: "Active",
                it: "Attivo"
            },
            actions: {
                el: "Επεξεργασία",
                en: "Actions",
                it: "Modifica"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            showAdditionalInfo: {
                el: "",
                en: "Show Additional Info",
                it: ""
            },
            redirect: {
                el: "Ανακατεύθυνση",
                en: "Redirect",
                it: "Reindirizzamento"
            },
            update: {
                el: "Ενημέρωση",
                en: "Update",
                it: "Aggiornamento"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            newStore: {
                el: "Νέο Κατάστημα",
                en: "New Store",
                it: "Nuovo negozio"
            },
            updateStore: {
                el: "Ενημέρωση Καταστήματος",
                en: "Update Store",
                it: "Aggiorna negozio"
            },
            updatePermissions: {
                el: "Ενημέρωση Εξουσιοδοτήσεων",
                en: "Update Permissions",
                it: "Aggiornare i permessi"
            },
            redirectMessageFirst: {
                el: "Πρόκειται να μεταφερθείτε στο κατάστημα ",
                en: "You are about to redirect to subsidiary ",
                it: "Stai per reindirizzare alla filiale "
            },
            redirectMessageSecond: {
                el: "Θέλετε να συνεχίσετε",
                en: "Do you want to continue",
                it: "Vuoi continuare"
            },
            selectPackage: {
                el: "Επιλογή Συνδρομής",
                en: "Select Subscription",
                it: "Opzione di abbonamento"
            },
            country: {
                el: "Χώρα",
                en: "Country",
                it: "Paese"
            },
            storeNameModal: {
                el: "Όνομα Καταστήματος",
                en: "Store Name",
                it: "Nome del negozio"
            },
            address: {
                el: "Διεύθυνση",
                en: "Address",
                it: "Indirizzo"
            },
            vatNumber: {
                el: "ΑΦΜ",
                en: "VAT Number",
                it: "NUMERO IVA"
            },
            emailOfStore: {
                el: "Email",
                en: "Email of Store",
                it: "Email"
            },
            primaryPhone: {
                el: "Τηλέφωνο",
                en: "Primary Phone",
                it: "Telefono"
            },
            networkRegion: {
                el: "Περιφέρεια",
                en: "Network Region",
                it: "Regione"
            },
            addNewStoreManager: {
                el: "Προσθήκη νέου διαχειριστή καταστήματος",
                en: "Add new store manager",
                it: "Aggiungere un nuovo gestore di negozio"
            },
            fullName: {
                el: "Ονοματεπώνυμο",
                en: "Full Name",
                it: "Nome e cognome"
            },
            iAccept: {
                el: "Αποδέχομαι",
                en: "I accept",
                it: "Accetto"
            },
            terms: {
                el: "τους Όρους Παροχής Υπηρεσιών",
                en: "Terms of Services",
                it: "i Termini di servizio"
            },
            and: {
                el: "και",
                en: "and",
                it: "e"
            },
            privacyPolicy: {
                el: "την Πολιτική Απορρήτου",
                en: "Privacy Policy",
                it: "l'Informativa sulla privacy"
            },
            digitalMarketing: {
                el: "το Direct Marketing",
                en: "Direct Marketing",
                it: "il Direct Marketing"
            },
            mobile: {
                el: "Τηλέφωνο",
                en: "Mobile",
                it: "Telefono"
            },
            addCoordinates: {
                el: "Εισάγετε τη διεύθυνση χειροκίνητα",
                en: "Enter the address manually",
                it: "Inserire manualmente l'indirizzo"
            },
            latitute: {
                el: "Γεωγραφικό πλάτος",
                en: "Latitute",
                it: "Latitudine"
            },
            longitude: {
                el: "Γεωγραφικό μήκος",
                en: "Longitude",
                it: "Longitudine"
            },
            zip: {
                el: "Ταχυδρομικός Κώδικας",
                en: "Postal Code",
                it: "Codice Postale"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            },
            visibleColumns: {
                el: "Ορατές Στήλες",
                en: "Visible Columns",
                it: "Colonne Visibili"
            },
            lastTransaction: {
                el: "Τελευταία Συναλλαγή",
                en: "Last Transaction",
                it: "Ultima Transazione"
            },
            pos: {
                el: "Ενεργό POS",
                en: "Enabled POS",
                it: "Abilitato POS"
            },
            status: {
                el: "Κατάσταση",
                en: "Status",
                it: "Status"
            },
            all: {
                el: "Όλα",
                en: "All",
                it: "Tutti"
            },
            daysWithoutTransaction: {
                el: "Ημέρες Χωρίς Συναλλαγή",
                en: "Days Without Transaction",
                it: "Giorni Senza Transazione"
            },
            id: {
                el: "Id",
                en: "Id",
                it: "Id"
            }
        }
    })
};
